import type { SSRData } from '@urql/vue';
import getWebClient from 'ui/graphql/web/getWebClient';

import geURQLClient, { ssr } from '../graphql/mma/config/index';
import { getConfig } from '../config/constants';

const ssrKey = '__URQL_DATA__';

export default defineNuxtPlugin((nuxt) => {
  const { vueApp } = nuxt;

  // when app is created in browser, restore SSR state from nuxt payload
  if (import.meta.client) {
    nuxt.hook('app:created', () => {
      ssr.restoreData(nuxt.payload[ssrKey] as SSRData);
    });
  }

  // when app has rendered in server, send SSR state to client
  if (import.meta.server) {
    nuxt.hook('app:rendered', () => {

      nuxt.payload[ssrKey] = ssr.extractData();
    });
  }

  const config = getConfig(useRuntimeConfig());

  // MMA client
  const client = geURQLClient(config.domains.api);
  nuxt.provide('urql', client);
  vueApp.provide('$urql', ref(client));

  // Web client
  const webClient = getWebClient(config.domains.api);
  nuxt.provide('urql-web', webClient);
  vueApp.provide('urql-web', ref(webClient));
});
